// ランチャーの構成チェック設定の、画面側の小さな決まり。
// @mcpanel/core の値（zod スキーマ）を画面から import すると、Node 専用のモジュールまで読み込んで
// 開発サーバー（vite dev）で画面が出なくなるので、型だけを core から取り、値はここに置く。正しい検証は API 側で行う。
import type { LauncherPolicy } from '@mcpanel/core';

export const defaultLauncherPolicy = (): LauncherPolicy => ({
  mode: 'warn',
  allowExtraMods: false,
  allowedExtraPatterns: [],
});

const PATTERN = /^[a-z0-9._-]{2,40}$/;

/** 改行・カンマ区切りの入力を一覧にする */
export function parsePatterns(text: string): string[] {
  return text
    .split(/[\n,]/)
    .map((p) => p.trim())
    .filter(Boolean);
}

/** 保存前の確認。問題があれば日本語の理由を返す */
export function policyProblem(policy: LauncherPolicy): string | null {
  const memory = policy.recommendedMemoryGb;
  if (memory !== undefined && (!Number.isInteger(memory) || memory < 1 || memory > 64))
    return '推奨メモリは 1〜64 GB の整数で入力してください';
  if (!['off', 'warn', 'block'].includes(policy.mode)) return 'モードが正しくありません';
  if (policy.allowedExtraPatterns.length > 50) return '許可する名前は 50 件までです';
  const bad = policy.allowedExtraPatterns.find((p) => !PATTERN.test(p));
  if (bad) return `「${bad}」は使えません（小文字の英数字・点・ハイフン・アンダースコアで 2〜40 文字）`;
  return null;
}
